module.exports = __webpack_public_path__ + "media/8.e8e19536.mp3";